import React from 'react'
import {
    FileItem,
    RedRibbon,
    IconSignPlus,
} from '@Knowledge-OTP/znk-ui-components'

const AddExamComponent = () => {


    // const color = 
    return (

        <div className='d-flex justify-content-between mb-7'>
            <div className='d-flex flex-row'

            >
                <FileItem
                    fileText={<div className='d-flex flex-column text-align-center'>
                        <RedRibbon
                            className='znk-ribbon-noexam ml-n4 mt-n2'
                            left='znk-ribbon-noexam left'
                            right=''
                        />
                        <IconSignPlus
                            size={20}
                            color={'#696CFF'}
                            className='mt-n7'
                            style={{ transform: 'rotate(45deg)' }}
                        />
                    </div>
                    }
                    className='align-items-center justify-content-center'
                    color={'newExam'}
                    size='medium-plus'
                />
            </div>
        </div>

    )


}

export default AddExamComponent